export default function TermsConditions() {
  return (
    <div style={pageStyle}>
      <div style={overlayStyle}>
        <div style={cardStyle}>
          <img src="/logo.png" alt="EduAt10" style={logoStyle} />

          <h1>Terms & Conditions</h1>

          <h3>English</h3>
          <p>
            By using EduAt10, you agree to use the platform only for educational
            purposes. Sharing credentials or misuse of content is prohibited.
          </p>
          <p>
            Subscription fees once paid are non-refundable except where required
            by law.
          </p>

          <h3>हिंदी</h3>
          <p>
            EduAt10 का उपयोग केवल शैक्षणिक उद्देश्यों के लिए किया जाना चाहिए।
          </p>
          <p>
            एक बार भुगतान की गई सदस्यता सामान्यतः रिफंड योग्य नहीं होती।
          </p>
        </div>
      </div>
    </div>
  );
}

/* ================= STYLES ================= */

const pageStyle = {
  minHeight: "100vh",
  backgroundImage: "url('/eduat10-bg.png')",
  backgroundSize: "cover",
};

const overlayStyle = {
  minHeight: "100vh",
  background: "rgba(0,0,0,0.25)",
  padding: 20,
};

const cardStyle = {
  background: "rgba(255,255,255,0.95)",
  maxWidth: 900,
  margin: "auto",
  padding: 30,
  borderRadius: 16,
};

const logoStyle = {
  width: 120,
  display: "block",
  margin: "0 auto 20px",
};
